import React, { useState, useEffect } from 'react';
import { Dialog, IconButton, Button } from "@material-ui/core";
import PhotoLibraryIcon from '@material-ui/icons/PhotoLibrary';
import CloseIcon from '@material-ui/icons/Close';
import { makeStyles } from '@material-ui/core/styles';
import ImageGallery from 'react-image-gallery';
import defaultParkingVideoImg from '../images/default_parking_video_img.jpg'

const useStyles = makeStyles({
    closeButton: {
        position: "absolute",
        top: 10,
        right: 10,
        borderRadius: 100,
        backgroundColor: "#00000060",
        display: "grid",
        justifyContent: "center",
        padding: 4,
        '&:hover': {
            cursor: "pointer"
        }
    },
    paperScrollPaper: {
        overflow: "visible",
        backgroundColor: "#0000",
        boxShadow: "none"
    }
});

export default function ImageGalleryDialog(props) {
    const classes = useStyles();
    const { record, source, getImages, style = {}, thumbnail, customButton, thumbnailStyle = {}, showMultipleThumbnails } = props;
    let defaultImg = "https://images.parksmart.in/main/Images/ParkingImages/default_parking.jpg"

    const [dialogVisible, setDialogVisible] = useState(false);
    const [galleryImages, setGalleryImages] = useState([]);

    const openDialog = () => {
        setDialogVisible(true);
    };

    const closeDialog = () => {
        setDialogVisible(false);
    };

    useEffect(() => {
        if (record != null) {
            if (getImages) {
                setGalleryImages(getImages(record)
                    .filter(uri => typeof uri === "string" && uri !== "")
                    .map(uri => {
                        if(uri.toLowerCase().endsWith('.mp4')){
                          return  {
                            original: uri, thumbnail: defaultParkingVideoImg,
                                renderItem: () => (
                                  <div className="video-wrapper">
                                    <video controls width="100%">
                                      <source src={uri} type="video/mp4" />
                                      Your browser does not support the video tag.
                                    </video>
                                  </div>
                                ),
                              }
                        }
                        return {original: uri, thumbnail: uri}
                    })
                );
            } else if (typeof record[source] === "string" && record[source] !== "") {
                const images = JSON.parse(record[source]);
                if (Array.isArray(images)) {
                    setGalleryImages(images
                       .map(uri => {
                        if(uri.toLowerCase().endsWith('.mp4')){
                          return  {
                            original: uri, thumbnail: defaultParkingVideoImg,
                                renderItem: () => (
                                  <div className="video-wrapper">
                                    <video controls width="100%">
                                      <source src={uri} type="video/mp4" />
                                      Your browser does not support the video tag.
                                    </video>
                                  </div>
                                ),
                              }
                        }
                        return {original: uri, thumbnail: uri}
                    })
                    );
                }
            }
        }
    }, [record, source, getImages]);

    if (record == null)
        return null;

    return (
        <div style={{ ...style }}>
            {galleryImages.length > 0 && !thumbnail && !customButton && <IconButton size='small' onClick={openDialog}>
                <PhotoLibraryIcon style={{ fontSize: 20 }} />
            </IconButton>}

            {galleryImages.length > 0 && thumbnail && !customButton && <div style={{ cursor: "pointer", position: "relative" }} onClick={openDialog}>
                {showMultipleThumbnails && galleryImages.length > 1 ? <img className='tableDataImg' src={galleryImages[1].original} style={{ position: "absolute", top: 7, left: 6, ...thumbnailStyle }} alt="parking" /> : null}
                <img className='tableDataImg' src={galleryImages.length > 0 ? galleryImages[0].original : defaultImg} style={{ position: "relative", boxShadow: showMultipleThumbnails && galleryImages.length > 1 ? "2px 3px 2px rgba(0, 0, 0, 0.2)" : "none", ...thumbnailStyle }} alt="parking" />
            </div>}

            {galleryImages.length > 0 && customButton &&
                <Button
                    variant='contained'
                    color="secondary"
                    disableElevation
                    size="small"
                    onClick={openDialog}
                    style={{ textTransform: "none", fontWeight: 500, fontSize: 14, fontFamily: "Poppins-Regular", padding: "10px 20px", letterSpacing: "0.06em", borderRadius: 10, backgroundColor: "#F5F8FA", color: "#334D6E" }}
                >
                    <PhotoLibraryIcon />
                </Button>
            }

            <Dialog open={dialogVisible} onClose={closeDialog} scroll="body" classes={{ paperScrollBody: classes.paperScrollPaper }}>
                <ImageGallery
                    items={galleryImages}
                    showPlayButton={false}
                    stopPropagation={true}
                />

                <div className={classes.closeButton} onClick={closeDialog}>
                    <CloseIcon style={{ fontSize: 30, color: "#fff" }} />
                </div>
            </Dialog>
        </div>
    );
}